function triggerEvent<EventDetail>(eventName: string, detail?: EventDetail) {
  const event = new CustomEvent(eventName, {
    detail,
  });

  document.dispatchEvent(event);
}

export { triggerEvent };
